import ActiveRecordResource from '../ActiveRecordResource';
import config from 'config';
import {AwsVideo} from '../videoAws';
import {NewsImage, NewsImageDTO} from "./newsImage";
import {UserDTO} from '../manager';
import {IVideoModel} from "../video";
import {LiveImage} from "../image";
import {YOUTUBE_REGEXP, VIMEO_REGEXP} from '../../utilites/helpers/constants';
import {VideoType} from '../../utilites/helpers/constants';

export const NewsImageContent = 'image';
export const NewsAWSContent = 'm3u8';
export const NewsVideoContent = 'video';
export const NewsLinkContent = 'link';
export const NewsYoutubeContent = 'youtube';
export const NewsVimeoContent = 'vimeo';

export interface NewsDTO {
  id?: string;
  club_id: string;
  title: string;
  content: string;
  message_type: string;
  image_url: NewsImageDTO;
  created_by: UserDTO;
  created_at: number;
  publish_at?: number;
  published: boolean;
  attachment?: {
    type: string;
    url: string;
  };
  video_url?: string;
  delete_video?: boolean;
  delete_image?: boolean;
  delete_attachment?: boolean;
}

export interface INewsEditForm {
  club_id: string;
  typeContent: string;
  title: string;
  content: string;
  link: string;
  image: LiveImage;
  video?: any;
  m3u8_url: string;
}

export default class News extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/news`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: NewsDTO): News {
    let res = new News({});

    return Object.assign(res, res._parseData(data));
  }

  title: string = '';
  content: string = '';
  club_id: string;
  public image: NewsImage;
  published: boolean = false;
  video: IVideoModel;
  createDate: Date;
  publishDate: Date;
  typeContent: string = NewsImageContent;

  _getModel() {
    return News;
  }

  get isPublished() {
    return this.published;
  }

  _parseData(data: NewsDTO) {
    let res: any = {
      id: data.id,
      title: data.title,
      club_id: data.club_id,
      content: data.content,
      published: data.published,
      createdBy: data.created_by,
      typeContent: NewsImageContent,
      createDate: new Date(data.created_at),
      publishDate: data.publish_at ? new Date(data.publish_at) : null,
      image: data.image_url ? new NewsImage(Object.assign(new NewsImageDTO(), data.image_url)) : null
    };

    if (data.attachment)
      switch (data.attachment.type) {
        case NewsAWSContent:
          res.typeContent = NewsAWSContent;
          res.video = new AwsVideo({isSaved: true, url: data.attachment.url});
          break;
        case NewsYoutubeContent:
        case NewsVimeoContent:
          res.typeContent = NewsLinkContent;
          res.link = data.attachment.url;
          break;
      }

    // if (data.attachment) {
    //   res.typeContent = NewsLinkContent;
    //   res.link = data.attachment.url;
    // } else if (data.video_url) {
    //   res.typeContent = NewsVideoContent;
    //   res.video = new AwsVideo({isSaved: true, url: data.video_url});
    // }

    return res;
  }

  _getExternalVideoType(url) {
    let youtubeMatches = YOUTUBE_REGEXP.exec(url);
    let vimeoMatches = VIMEO_REGEXP.exec(url);
    let s = {};

    s[VideoType.YOUTUBE] = "youtube";
    s[VideoType.VIMEO] = "vimeo";

    if (youtubeMatches) return s[VideoType.YOUTUBE];
    if (vimeoMatches) return s[VideoType.VIMEO];
    return null;
  };

  prepareForSave(newData: INewsEditForm): any {
    let {content, title, image, video, typeContent, club_id} = newData;

    let data: any = {title, content, club_id};

    switch (typeContent) {
      case NewsLinkContent:
        data.attachment_type = this._getExternalVideoType(newData.link);
        data.attachment_url = newData.link;
        break;
      case NewsAWSContent:
        if (video && video instanceof AwsVideo) {
          data.attachment_type = NewsAWSContent;
          data.attachment_url = video.url;
        }
        break;
    }

    // delete video or link to YouTube
    if (this.typeContent !== newData.typeContent) {
      switch (this.typeContent) {
        case NewsLinkContent:
          data.delete_attachment = true;
          break;
        case NewsAWSContent:
          data.delete_video = true;
      }
    }

    if (image && !image.isSaved) {
      data.image = image.file;
    }

    return data;
  }

  async publish(): Promise<News> {
    let response = await this._networkLayer.patch(this._prepareUrl(this.id) + '/publish');

    let data = await response.json();

    this._extendData(data);

    return this;
  }

  async share(): Promise<string> {
    let response = await this._networkLayer.patch(this._prepareUrl(this.id) + '/share');
    let {url} = await response.json();

    return url;
  }
}



// WEBPACK FOOTER //
// ./src/api/news/news.ts